var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "用户权限",
            visible: _vm.drawer,
            direction: _vm.direction,
            "before-close": _vm.handleClose,
            modal: true,
            "wrapper-closable": true,
            "with-header": false,
            size: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "table-box" }, [
              _c(
                "span",
                {
                  class: { on: _vm.activeName == 0 },
                  on: {
                    click: function ($event) {
                      _vm.activeName = 0
                    },
                  },
                },
                [_vm._v(" 编辑权限 ")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tree-box" },
              [
                _vm.userInfo
                  ? _c(
                      "div",
                      { staticClass: "form-box" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "ruleForm",
                            staticClass: "demo-ruleForm",
                            attrs: {
                              model: _vm.userInfo,
                              rules: _vm.rules,
                              "label-width": "90px",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "用户角色：" } },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          multiple: "",
                                          size: "small",
                                          placeholder: _vm.$t(
                                            "setting.edit.pleaseselect"
                                          ),
                                        },
                                        on: { change: _vm.handleRoles },
                                        model: {
                                          value: _vm.pageData.roles,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.pageData, "roles", $$v)
                                          },
                                          expression: "pageData.roles",
                                        },
                                      },
                                      _vm._l(
                                        _vm.pageData.roleList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v(_vm._s(_vm.$t("setting.edit.text2"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("rolesTree", {
                  ref: "rolesTree",
                  attrs: {
                    "tree-data": _vm.pageData.menus,
                    "default-checked-keys": _vm.defaultCheckedKeys,
                    "roles-list": _vm.rolesList,
                    "is-admin": true,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("public.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }